export class SearchParamsService {
  public static getParams(searchParams: URLSearchParams) {
    return [...searchParams.entries()].reduce(
      (acc, [key, value]) => ({ ...acc, [key]: value }),
      {} as { [k: string]: string },
    );
  }
}
